module Meevo.Components.Controls {

    class PaginationController implements angular.IComponentController {
        public totalCount: number;
        public itemsPerPage: number;
        public currentPage: number;
        public onPageChange: () => void;

        public get maxPage() {
            return Math.ceil(this.totalCount / this.itemsPerPage)
        };

        public get selectablePages() {
            let pages;
            if (this.maxPage >= 8) {
                switch (this.currentPage) {
                    case 0:
                    case 1:
                    case 2:
                        pages = [0, 1, 2, "...", this.maxPage - 1];
                        break;
                    case this.maxPage - 3:
                    case this.maxPage - 2:
                    case this.maxPage - 1:
                        pages = [0, "...", this.maxPage - 3, this.maxPage - 2, this.maxPage - 1];
                        break;
                    default:
                        pages = [
                            0,
                            "...",
                            this.currentPage - 2,
                            this.currentPage - 1,
                            this.currentPage,
                            this.currentPage + 1,
                            this.currentPage + 2,
                            "...",
                            this.maxPage - 1
                        ];
                        break;
                }
            } else {
                pages = [];
                for (let i = 0; i < this.maxPage; i++) {
                    pages.push(i);
                }
            }
            return pages;
        }

        public selectPage(page: number) {
            if (page < 0 || page > this.maxPage - 1 || this.currentPage == page) {
                return;
            }
            this.currentPage = page;
            setTimeout(this.onPageChange, 0);
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoPagination', <angular.IComponentOptions> {
            templateUrl: 'app/components/controls/pagination/pagination.temaplate.html',
            bindings: {
                totalCount: '=',
                itemsPerPage: '=',
                currentPage: '=',
                onPageChange: '&',
            },
            controller: PaginationController
        });
}